// extracted by mini-css-extract-plugin
var _1 = "lKKy1";
var _2 = "aDOq1";
export { _1 as "searchButton", _2 as "searchButtonWrapper" }
